/**
 * Cookie Notice JS
 * @author Alessandro Benoit
 * modifié par artwaï pour artwaï
 */

 (function () {

    "use strict";

    /**
     * Store current instance
     */
    let instance;

    /**
     * Defaults values
     * @type object
     */
    const defaults = {
        'messageLocales': {
            'en': 'We use cookies to make sure you can have the best experience on our website. If you continue to use this site we assume that you will be happy with it.',
            'fr': 'En poursuivant votre navigation, vous acceptez l\'installation de quelques cookies. '
        },
        
        'learnMoreLinkEnabled': true,
        'buttonKO': true,

        'learnMoreLinkHref': '/politique-de-confidentialite/',

        'learnMoreLinkText': {
            'en': 'Privacy policy',
            'fr': 'Politique de confidentialité'
        },

        'buttonOKLocales': {
            'en': 'OK, I ACCEPT',
            'fr': 'OK, J\'ACCEPTE'
        },
        'buttonKOLocales': {
            'en': 'No, thank you.',
            'fr': 'Non, merci.'
        },

        'buttonOKClass': 'btn btn-block',
        'buttonKOClass': 'btn btn-block btn-darkgrey',

        'expiresIn': 180,
    };

    /**
     * Initialize cookie notice on DOMContentLoaded
     * if not already initialized with alt params
     */
    document.addEventListener('DOMContentLoaded', () => {
        if (!instance) {
            new cookieConsentJS();
        }
    });

    /**
     * Constructor
     * @constructor
     */
    window.cookieConsentJS = function () {

        // If an instance is already set stop here
        if (instance !== undefined) {
            return;
        }

        // Set current instance
        instance = this;

        // If cookies are not supported or notice cookie is already set
        if (!testCookie() || getNoticeCookie()) {
            return;
        }

        // Extend default params
        const params = extendDefaults(defaults, arguments[0] || {});

        // Get current locale for notice text
        let noticeText = getStringForCurrentLocale(params.messageLocales);


        let learnMoreLink;

        if (params.learnMoreLinkEnabled) {
            const learnMoreLinkText = getStringForCurrentLocale(params.learnMoreLinkText);

            learnMoreLink = createLearnMoreLink(learnMoreLinkText, params.learnMoreLinkHref);

            noticeText += ' Pour en savoir plus :';
        }
        // Create notice
        const notice = createNotice(noticeText);

        // Get current locale for button OK text
        let buttonText = getStringForCurrentLocale(params.buttonOKLocales);

        // Create dismiss button
        const dismissOKButton = createDismissButton(buttonText, 'confirm ' + params.buttonOKClass);
        let dismissKOButton;

        // Dismiss button click event
        dismissOKButton.addEventListener('click', e => {
            e.preventDefault();
            setDismissNoticeCookie(parseInt(params.expiresIn + "", 10) * 60 * 1000 * 60 * 24, 1);
            notice.classList.remove('fadein');

        });

        const buttonKO = params.buttonKO;
        if (!!buttonKO) {
            // Get current locale for button KO text
            buttonText = getStringForCurrentLocale(params.buttonKOLocales);

            // Create dismiss button
            dismissKOButton = createDismissButton(buttonText, 'invalidate ' + params.buttonKOClass);

            // Dismiss button click event
            dismissKOButton.addEventListener('click', e => {
                e.preventDefault();
                setDismissNoticeCookie(parseInt(params.expiresIn + "", 10) * 60 * 1000 * 60 * 24, 0);
                notice.classList.remove('fadein');
            });
        }

        // Append notice to the DOM
        const noticeDomElement = document.body.appendChild(notice);

        if (!!learnMoreLink) {
            notice.appendChild(learnMoreLink);
        }
        noticeDomElement.appendChild(dismissOKButton);

        if (!!buttonKO) {
            noticeDomElement.appendChild(dismissKOButton);
        }

        //setTimeout(function () {
            noticeDomElement.classList.add('fadein');
        //}, 1); 
    };

    /**
     * Get the string for the current locale
     * and fallback to "en" if none provided
     * @param locales
     * @returns {*}
     */
    function getStringForCurrentLocale(locales) {
        const locale = (navigator.userLanguage || navigator.language).substr(0, 2);
        return (locales[locale]) ? locales[locale] : locales['en'];
    }

    /**
     * Test if cookies are enabled
     * @returns {boolean}
     */
    function testCookie() {
        document.cookie = 'testCookie=1; path=/;';
        return document.cookie.indexOf('testCookie') !== -1;
    }

    /**
     * Test if notice cookie is there
     * @returns {boolean}
     */
    function getNoticeCookie() {
        return document.cookie.indexOf('consent_statistiques') !== -1;
    }

    /**
     * Create notice
     * @param message
     * @returns {HTMLElement}
     */
    function createNotice(message) {

        const notice = document.createElement('div');
        notice.innerHTML = message;
        notice.setAttribute('id', 'cookieNotice');


        return notice;
    }

    /**
     * Create dismiss button
     * @param message
     * @returns {HTMLElement}
     */
    function createDismissButton(message, buttonClass) {

        const dismissButton = document.createElement('a');

        // Dismiss button
        dismissButton.href = '#';
        dismissButton.innerHTML = message;

        dismissButton.className = buttonClass;

        return dismissButton;

    }

    /**
     * Create dismiss button
     * @param learnMoreLinkText
     * @param learnMoreLinkHref
     * @param linkColor
     * @returns {HTMLElement}
     */
    function createLearnMoreLink(learnMoreLinkText, learnMoreLinkHref) {

        const learnMoreLink = document.createElement('a');

        // Dismiss button
        learnMoreLink.href = learnMoreLinkHref;
        learnMoreLink.textContent = learnMoreLinkText;
        learnMoreLink.className = 'learn-more';

        return learnMoreLink;

    }

    /**
     * Set sismiss notice cookie
     * @param expireIn
     */
    function setDismissNoticeCookie(expireIn, value) {
        var dateNow = new Date();
        var dateNowTmp = new Date();
        var dateExpire = new Date(dateNowTmp.setTime( dateNowTmp.getTime() + expireIn));

        var valueObj = {
            value: value,
            datebegin: dateNow.toISOString().split("T")[0],
            dateexpires: dateExpire.toISOString().split("T")[0],
        };
        
        document.cookie = 'consent_statistiques=' + JSON.stringify(valueObj) + ';expires=' + dateExpire + ';path=/;';

        if (value == 1) {
            console.log("COOKIE : Vous avez explicitement accepté l'utilisation des cookies");
        }
        if (document.getElementById("consent_statistiques_user_choice")) {
            document.location.reload(true);
        }

        
    }

    /**
     * Utility method to extend defaults with user options
     * @param source
     * @param properties
     * @returns {*}
     */
    function extendDefaults(source, properties) {
        let property;
        for (property in properties) {
            if (properties.hasOwnProperty(property)) {
                if (typeof source[property] === 'object') {
                    source[property] = extendDefaults(source[property], properties[property]);
                } else {
                    source[property] = properties[property];
                }
            }
        }
        return source;
    }

}());